export const buildOrderByIdCriteria = (primaryId, companyPrimaryId) => ({
  primaryId,
  company: {
    primaryId: companyPrimaryId
  }
});

export const buildPrimaryIdCriteria = (primaryId) => ({
  primaryId
});

export const buildPaidOrdersCriteria = (accountId, companyPrimaryId, currentStatus = "PAID") => ({
  accountId,
  currentStatus,
  company: {
    primaryId: companyPrimaryId
  }
});

export const buildInvoiceByOrderCriteria = (accountId, orderId) => ({
  user: {
    primaryId: accountId
  },
  order: {
    primaryId: orderId
  }
});

export const buildOrderUpdateEndpoint = (endpoint, updateType = "") => (
  `${endpoint}?type=${encodeURIComponent(updateType || "")}`
);

export const normalizeOrderByIdCriteria = (criteriaOrPrimaryId, companyPrimaryId) => {
  if (
    criteriaOrPrimaryId
    && typeof criteriaOrPrimaryId === "object"
    && !Array.isArray(criteriaOrPrimaryId)
  ) {
    return criteriaOrPrimaryId;
  }

  return buildOrderByIdCriteria(criteriaOrPrimaryId, companyPrimaryId);
};
